import React from "react";
import {cx} from "../../lib/ClassSet";
import "./CustomerAccessItem.css";

const CustomerAccessItem = (props) => {

  let {data} = props;

  let classes = cx({
    "item": true,
    "accounts-customer-access-list-item": true,
    "u-selected": props.selected
  })

  let roles = data.get("roles").map(role => {
    return (
      <span key={role} className={`role u-role-${role}`}>{role}</span>
    )
  })

  let nameClickFn = (e) => { props.onClick(data, e, "name") }

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-name"><span onClick={nameClickFn}>{data.get("name")}</span></td>
      <td className="field f-email">{data.get("email")}</td>
      <td className="field f-roles">{roles}</td>
    </tr>
  )
}

export default CustomerAccessItem;